// calculates if it is overtime based on the matchStatusId and how many minutes
import getPeriodLengthFromMatchLength from '../components/MatchWatch/helpers/getPeriodLengthFromMatchTime';
import getExtraTimePeriodLengthFromMatchLength from '../components/MatchWatch/helpers/getExtraTimePeriodLengthFromMatchLength';
import { MatchStatus } from '../enums/matchStatus';
import Period from '../enums/period';

export default function (minutes: number, matchLength: string, matchStatusId?: MatchStatus, periodId?: Period): number {
  if (periodId) {
    if (periodId === Period.FIRST_HALF) {
      const overtime = minutes - getPeriodLengthFromMatchLength(matchLength);

      if (overtime > 0) return overtime;
    } else if (periodId === Period.SECOND_HALF) {
      const overtime = minutes - getPeriodLengthFromMatchLength(matchLength) * 2;

      if (overtime > 0) return overtime;
    } else if (periodId === Period.FIRST_HALF_EXTRA_TIME) {
      const overtime =
        minutes -
        getPeriodLengthFromMatchLength(matchLength) * 2 -
        getExtraTimePeriodLengthFromMatchLength(matchLength);

      if (overtime > 0) return overtime;
    } else if (periodId === Period.SECOND_HALF_EXTRA_TIME) {
      const overtime =
        minutes -
        getPeriodLengthFromMatchLength(matchLength) * 2 -
        getExtraTimePeriodLengthFromMatchLength(matchLength) * 2;

      if (overtime > 0) return overtime;
    }
  } else if (matchStatusId) {
    if (matchStatusId === MatchStatus.FIRST_HALF) {
      const overtime = minutes - getPeriodLengthFromMatchLength(matchLength);

      if (overtime > 0) return overtime;
    } else if (matchStatusId === MatchStatus.SECOND_HALF) {
      const overtime = minutes - getPeriodLengthFromMatchLength(matchLength) * 2;

      if (overtime > 0) return overtime;
    } else if (matchStatusId === MatchStatus.FIRST_HALF_EXTRA_TIME) {
      const overtime =
        minutes -
        getPeriodLengthFromMatchLength(matchLength) * 2 -
        getExtraTimePeriodLengthFromMatchLength(matchLength);

      if (overtime > 0) return overtime;
    } else if (matchStatusId === MatchStatus.SECOND_HALF_EXTRA_TIME) {
      const overtime =
        minutes -
        getPeriodLengthFromMatchLength(matchLength) * 2 -
        getExtraTimePeriodLengthFromMatchLength(matchLength) * 2;

      if (overtime > 0) return overtime;
    }
  }

  return 0;
}
